import GeneralElectionToAssemblyConstituency from "./GeneralElection_to_AssemblyConstituency"

export const tabs = [
    {
        key: 1,
        label:"General Election to Assembly Constituency",
        count:'0',
        content: <GeneralElectionToAssemblyConstituency/>
    },
    {
        key: 2,
        label:"General Election to Parliamentary Constituency",
        count:'2',
        content: <GeneralElectionToAssemblyConstituency/>
    },
    {
        key: 3,
        label:"Bye Election to Assembly Constituency",
        count:'0',
        content: <GeneralElectionToAssemblyConstituency/>
    },
    { 
        key: 4,
        label:"Bye Election to Parliamentary Constituency",
        count:'0',
        content: <GeneralElectionToAssemblyConstituency/> 
    }
]